module.exports = __webpack_public_path__ + "static/media/icon5.95634c9e.svg";